import { useState, useRef } from 'react';
import { MdSearch } from 'react-icons/md';
import { FlexBox, Input, Button } from 'components';

const Task06 = () => {
  const [inputValue, setInputValue] = useState('');
  const searchRef = useRef(null);

  return (
    <FlexBox wrapped="wrap">
      <Input
        name="searchT06"
        value={inputValue}
        placeholder="Lookung for something?"
        onChange={e => setInputValue(e.target.value)}
        icon={<MdSearch />}
        ref={searchRef}
      />
      <Button
        caption="Search"
        onClick={() => {
          searchRef.current.focus();
        }}
      />
    </FlexBox>
  );
};

export default Task06;
